import React from 'react'
import { Modal } from '@scuf/common'
import AssetManagementTable from '../../../../AssetManagementTable'
import { ModalTitle, ModalWrap } from './dropped-devices-modal.styles'

export const columns = (t, flags = {}) => {
  const visibleColumns = [];
  visibleColumns.push({ field: 'key', translation: 'AssetManagementTable_faultyDotsSerialNumber', render: null });
  visibleColumns.push({ field: 'aliasName', translation: 'AssetManagementTable_alias', render: null });
  visibleColumns.push({ field: 'hardImpact', translation: 'AssetManagementTable_hardImpact', render: null });
  if (flags.softImpact) {
    visibleColumns.push({ field: 'softImpact', translation: 'AssetManagementTable_softImpact', render: null });
  }
  if (flags.freeFalls) {
    visibleColumns.push({ field: 'freeFall', translation: 'AssetManagementTable_freeFall', render: null });
  }
  visibleColumns.push({ field: 'siteId', translation: 'AssetManagementTable_deviceSite', render: null });
  return visibleColumns;
};

const TypesOfModelModal = ({ data, t, flags }) => (
  <ModalWrap>
    <ModalTitle>{t('DroppedDevices_Title')}</ModalTitle>
    <Modal.Content>
      <AssetManagementTable
        data={data}
        columns={columns(t, flags)}
        disableRowClick
        fileName={t('DroppedDevices_Title')}
      />
    </Modal.Content>
  </ModalWrap>
)

export default TypesOfModelModal
